export default __webpack_public_path__ + "static/misc5-68eb11cc0fc5f70e7aa1aa4e36d13262.jpg";